import defaultSource from "./defaultSource";
import irwinHall from "./irwinHall";

export default (function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/bates.js
// module id = 603
// module chunks = 4